import { Action } from 'redux';
import { isType } from 'typescript-fsa';
import * as actions from './actions';
import { BlockedEmailsState } from './types';

const initialState: BlockedEmailsState = {
	blockedEmails: [],
	isLoadingBlockedEmails: false,
};

export function blockedEmailsReducer(
	state: BlockedEmailsState = initialState,
	action: Action
): BlockedEmailsState {
	if (isType(action, actions.getBlockedEmailsAction.started)) {
		return { ...state, isLoadingBlockedEmails: true };
	}
	if (isType(action, actions.getBlockedEmailsAction.done)) {
		return {
			...state,
			blockedEmails: action.payload.result,
			isLoadingBlockedEmails: false,
		};
	}
	if (isType(action, actions.getBlockedEmailsAction.failed)) {
		return { ...state, isLoadingBlockedEmails: false };
	}

	return state;
}
